import { render, staticRenderFns } from "./ImageZoomViewer.vue?vue&type=template&id=3cf95c4e&scoped=true&lang=pug"
import script from "./ImageZoomViewer.vue?vue&type=script&lang=js"
export * from "./ImageZoomViewer.vue?vue&type=script&lang=js"
import style0 from "./ImageZoomViewer.vue?vue&type=style&index=0&id=3cf95c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf95c4e",
  null
  
)

export default component.exports